import { FERTILITY_CLASS_TO_SITE_TYPE } from '@/types/generated/forest_models';

/**
 * MV1.9 fertility class -> site-type display label, read from the generated
 * copy of the ONE forest_models table (never a third literal).
 */
export function getSiteTypeLabel(fertilityClass: string | number | null | undefined): string | null {
  if (fertilityClass == null) return null;
  return FERTILITY_CLASS_TO_SITE_TYPE[String(fertilityClass)] ?? null;
}
